import { rgba } from 'polished';
import { index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 100%;

  .fc {
    ${({ theme }) => typographyToCss(theme.typography.body2)};
    height: 100%;
    z-index: ${index(Options.PAGE)};

    color: ${({ theme }) => theme.palette.text.primary};
  }

  .fc table {
    border-width: 0;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-body:first-child {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc .fc-scrollgrid-section-sticky > * {
    background: transparent;
  }

  /* Header cells */
  .fc .fc-day-sat,
  .fc .fc-day-sun {
    background-color: ${({ theme }) => rgba(theme.palette.grey[50], 0.5)};
  }

  /* TimeGrid columns (where events are) */
  .fc .fc-timegrid-col.fc-day-sat,
  .fc .fc-timegrid-col.fc-day-sun {
    background-color: ${({ theme }) => rgba(theme.palette.grey[50], 0.5)};
  }

  .fc .fc-col-header-cell-cushion {
    padding: ${({ theme }) => theme.spacing(2)};
  }

  .fc-header-toolbar {
    display: none;
  }

  .fc-timegrid-divider {
    display: none;
  }

  .fc-timegrid-col,
  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-more-popover {
    visibility: hidden;
    height: 0;
    width: 0;
    overflow: hidden;
  }

  /* Set the "+N more" link size explicitly (rem, not the inherited em-scaled
     base) so it's the true overline size and identical across week/month. */
  .fc .fc-daygrid-more-link {
    ${({ theme }) => typographyToCss(theme.typography.overline)};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .fc .fc-daygrid-day-top {
    display: flex;
    align-items: center;
    padding: ${({ theme }) => `0 ${theme.spacing(1)} 0 0`};
    height: 2.6rem;
  }

  .fc-daygrid-day.fc-day-today,
  .fc-timegrid-col.fc-day-today {
    background: inherit;

    .fc-daygrid-day-number {
      padding: ${({ theme }) => `0 ${theme.spacing(1)}`};
      background: ${({ theme }) => theme.palette.error.main};
      color: ${({ theme }) => theme.palette.error.contrastText};
      border-radius: ${({ theme }) => theme.spacing(1.5)};
    }
  }

  .fc-timegrid-event .fc-event-main {
    padding: 0;
  }

  .fc .fc-highlight {
    background: ${({ theme }) =>
      theme.palette.primaryExtended.opacityBackgroundBackground};
  }

  .fc-day {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc .fc-col-header-cell {
    border-right-color: transparent;
    border-left-color: transparent;
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc-scrollgrid-section td,
  .fc-scrollgrid-section th {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-scrollgrid-section .fc-timegrid-slot-minor {
    border-top-color: transparent;
  }

  .fc-event {
    padding: 0;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
`;
